<template>
    <div>
        <v-text-field v-model="search"
            hide-details
            label="Pesquisar...">
        </v-text-field>
        <div class="mb-4" v-for="categoria, ci in Array.from(new Set(computedLinks.map(i => i.categoria)))" :key="'links-categoria-'+ci">
            <v-divider class="my-2"></v-divider>
            <v-alert color="primary">
                {{categoria}}
            </v-alert>
            <v-row class="mt-2">
                <v-col cols="12" sm="12"
                    v-for="link, index in computedLinks.filter(i => i.categoria==categoria)"
                    :key="'col-link-'+index">
                    <v-list-item two-line :href="link.link"
                        target="_blank" elevation="0">
                        <v-list-item-title>
                            <v-icon size="x-small" class="mb-1">mdi-web</v-icon>
                            {{link.label}}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{link.link}}</v-list-item-subtitle>
                    </v-list-item>
                </v-col>
            </v-row>
        </div>
   </div>
</template>
<script>
export default {
    data:()=>({
        search:''
    }),
    methods:{
    },
    computed:{
        computedLinks(){
            let links = this.$verify.links_uteis
            if (this.search) {
                links = links.filter( obj => obj.label.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
            }
            return links
        }
    },
}
</script>
